import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["ComboboxInput"], _mergeProps({
        "display-value": $props.displayValue,
        disabled: $props.disabled,
        readonly: $props.readonly
    }, $setup.attrs, {
        class: $setup.cn('flex-1 min-w-0 bg-transparent text-sm outline-none', 'placeholder:text-muted-foreground', 'not-placeholder-shown:text-en-blue-500', 'disabled:cursor-not-allowed read-only:cursor-not-allowed', $setup.props.class)
    }), null, 16 /* FULL_PROPS */, ["display-value", "disabled", "readonly", "class"]));
}
